<template>
  <div>
    <article class="con4">
      <div class="inner container">
        <p>지원문의</p>
        <ul>
          <li>㈜캐럿글로벌 HR팀</li>
          <li>TEL : (02)518-5468</li>
          <li>E-mail : recruit@carrotglobal.com</li>
          <li>주소 : 서울특별시 서초구 강남대로 479 신논현타워 6F</li>
        </ul>
      </div>
    </article>
  </div>
</template>

<script>
import "@/assets/style/newGlobalReset.scss";

export default {};
</script>

<style lang="scss" scoped>
.con4 {
  padding: 40px 0;

  @media screen and (min-width: 1350px) {
    padding: 80px 0;
  }

  .inner {
    display: flex;
    justify-content: center;
    gap: 20px;

    > p {
      font-size: 18px;
      font-weight: 700;
    }

    ul {
      font-size: 18px;

      li {
        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>
